
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.5","height":"23.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.75 0A11.75 11.75 0 110 11.75 11.75 11.75 0 0111.75 0z","fill":"#ea344b"}}),_c('g',{attrs:{"fill":"#fcfcfe"}},[_c('path',{attrs:{"d":"M11.869 14.664a2.85 2.85 0 002.786-2.893V7.564a2.789 2.789 0 00-2.688-2.886h-.1a2.791 2.791 0 00-2.785 2.695v4.391a2.851 2.851 0 002.787 2.9z"}}),_c('path',{attrs:{"d":"M16.182 10.018a.524.524 0 00-.517.519v1.23a3.8 3.8 0 11-7.595.105v-1.343a.515.515 0 00-1.031 0v1.233a4.822 4.822 0 004.315 4.8v1.464h-1.333a.52.52 0 00-.519.512.516.516 0 00.515.522h3.706a.517.517 0 100-1.034h-1.336v-1.464a4.821 4.821 0 004.314-4.8v-1.236a.521.521 0 00-.519-.508z"}})])])
          )
        }
      }
    